import axios from 'axios';
import { BestMixFeed } from 'views/feed-management/features/best-mix-feeds/types/best-mix-feed.type';
import { BestMixFeedListItem } from 'views/feed-management/features/best-mix-feeds/types/best-mix-feed-list-item.type';

// GET
// Returns a product.
// /ewosapi/v1/bestmix/product/{code}
export const getFeedManagementBestMixFeed = async (code: string): Promise<BestMixFeed> => {
  //   return BestMixFeedData;
  const res = await axios.get<BestMixFeed>(`/ewosapi/v1/bestmix/product/${code}`);
  return res.data;
};

// GET
// Returns list of all products (active or inactive) produced by plants assoicated with user markets.
// /ewosapi/v1/bestmix/product
export const getFeedManagementBestMixFeeds = async (): Promise<BestMixFeedListItem[]> => {
  //   return BestMixFeedsData;
  const res = await axios.get<BestMixFeedListItem[]>(`/ewosapi/v1/bestmix/product/all`);
  return res.data;
};

// GET
// Returns list of all active products produced by plants assoicated with user markets.
// /ewosapi/v1/bestmix/product
export const getActiveFeedManagementBestMixFeeds = async (): Promise<BestMixFeedListItem[]> => {
  //return ListBestMixFeeds;
  const res = await axios.get<BestMixFeedListItem[]>(`/ewosapi/v1/bestmix/product/active`);
  return res.data;
};
